<template>
  <WsMain>
    <WsReadSection
      :id="_id"
      :modelName="modelName"
      :label="label"
      :fields="fields"
      :leftFields="leftFields"
      :rightFields="rightFields"
    ></WsReadSection>
  </WsMain>
</template>

<script>
import model from "@/__vue2stone_cms/models/tulpa_section_template";
export default {
  data: () => ({
    modelName: model.modelName,
    label: model.label,
    fields: model.fields,
    leftFields: ["name", "component_name", "fields"],
    rightFields: ["remark"],
  }),

  computed: {
    _id() {
      return this.$route.params.id;
    },
  },
};
</script>

<style>
</style>